import PropTypes from 'prop-types';
import React from 'react';
import time from 'yoda-core-components/lib/moment/Time';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { masterCardHistory } from '../../../common/Constants';

const NewActivityHistoryData = ({ data, onGetDetails }) => {
    const rows = data || [];
    return (
        <div>
            {rows.map((item, i) => {
                const isMissingPointsData = item?.typeDescription === masterCardHistory;
                const transactionLabel = isMissingPointsData
                    ? item?.bonusIconTypes?.[0]?.iconDescription
                    : item?.typeDescription || item?.description?.payment?.typeDescription;

                return (
                    <div
                        key={i} // eslint-disable-line react/no-array-index-key
                        className={dt([
                            'flex', 'flex-col', 'md:flex-row', 'md:justify-between',
                            'border-b', 'border-solid', 'border-[#D8D8D8]',
                            'bg-white',
                        ])}
                    >
                        {/* Left: date + transaction type */}
                        <div className={dt(['flex', 'flex-col', 'pt-4', 'px-4', 'pb-4', 'gap-1'])}>
                            <span className={dt(['text-small', 'text-black'])}>
                                {time(item.date).format('MMM DD, YYYY')}
                            </span>
                            {item.id ? (
                                <button
                                    type="button"
                                    data-automation-id="at-activity-transaction-details"
                                    className={dt(['text-left', 'text-small', 'text-black', 'underline'])}
                                    onClick={(e) => onGetDetails(item, e)}
                                >
                                    {transactionLabel}
                                </button>
                            ) : (
                                <span className={dt(['text-small', 'text-black', 'underline'])}>
                                    {transactionLabel}
                                </span>
                            )}
                        </div>

                        {/* Right: points — gray-05 bg */}
                        <div className={dt([
                            'flex', 'flex-row', 'md:flex-col', 'justify-between', 'md:justify-center', 'items-center',
                            'py-3', 'px-4', 'bg-[#F2F2F2]', 'md:min-w-[80px]',
                        ])}>
                            <span className={dt(['font-semibold', 'text-small', 'text-black', 'leading-5'])}>
                                {item.points}
                            </span>
                            <span className={dt(['text-small', 'text-[#4D4D4D]', 'leading-5'])}>
                                Points
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

NewActivityHistoryData.propTypes = {
    data: PropTypes.array.isRequired,
    onGetDetails: PropTypes.func.isRequired,
};

export default NewActivityHistoryData;
